export default "__VITE_ASSET__Ho2f6I7v__"